import { MemberGroups } from "shared-types";
import { getUserGroup } from "../services/authorization";

export function checkIsAgent() {
  return getUserGroup() === MemberGroups.agent;
}
